export default {
  fields: {
    sales: {
      label: 'Salg',
    },
    gift_cards_sales: {
      label: 'Gavekortsalg',
    },
    average_order_value: {
      label: 'Gennemsnitlig ordreværdi',
    },
    savings: {
      label: 'Besparelse på tredjepartsgebyrer',
    },
    reservations: {
      label: 'Reservationer',
    },
    sales_from_email: {
      label: 'Salg fra e-mail',
    },
    sales_from_google_seo: {
      label: 'Salg fra Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Salg fra Google Business',
    },
    sales_from_google_ads: {
      label: 'Salg fra Google Ads',
    },
    sales_from_flyers: {
      label: 'Salg fra flyers',
    },
    sales_from_social_media: {
      label: 'Salg fra sociale medier',
    },
    sales_from_facebook_ads: {
      label: 'Salg fra Facebook Ads',
    },
    tips: {
      label: 'Drikkepenge',
    },
    new_customers: {
      label: 'Nye kunder',
    },
    returning_customers: {
      label: 'Tilbagevendende kunder',
    },
    new_visitors: {
      label: 'Nye besøgende',
    },
    new_followers: {
      label: 'Nye følgere',
    },
    total_followers: {
      label: 'Følgere i alt',
    },
    delivered_messages: {
      label: 'Leverede beskeder',
    },
    average_open_rate: {
      label: 'Gennemsnitlig åbningsrate for e-mails',
    },
    average_click_rate: {
      label: 'Gennemsnitlig klikrate',
    },
    website_visitors_from_email: {
      label: 'Webstedsbesøgende fra e-mail',
    },
    sales_from_google_business: {
      label: 'Salg fra Google Business',
    },
    total_reservations: {
      label: 'Reservationer',
    },
    website_visitors_from_google_seo: {
      label: 'Webstedsklik fra Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Webstedsklik fra Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Webstedsklik fra Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Webstedsklik fra sociale medier',
    },
    calls_from_google_ads: {
      label: 'Opkald fra Google Ads',
    },
    directions_from_google_ads: {
      label: 'Rutevejledninger fra Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Sociale medier',
    },
    flyer_orders_count: {
      label: 'Flyers',
    },
    email_orders_count: {
      label: 'E-mails',
    },
    other_orders_count: {
      label: 'Andre',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Gavekort',
    },
    net_billed_revenue: {
      label: 'Faktureret omsætning (netto)',
    },
    net_billed_revenue_subscription: {
      label: 'Faktureret abonnementsomsætning',
    },
    net_billed_revenue_service_fee: {
      label: 'Faktureret servicegebyromsætning',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Faktureret leveringsgebyromsætning',
    },
    net_billed_revenue_other: {
      label: 'Faktureret omsætning fra servicetillæg',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Faktureret levering – viderefakturering',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Faktureret omsætning fra platformens behandlingsgebyr',
    },
    gross_cash_income: {
      label: 'Kontantindtægt (brutto)',
    },
    gross_cash_income_subscription: {
      label: 'Kontantindtægt fra abonnementer',
    },
    gross_cash_income_service_fee: {
      label: 'Kontantindtægt fra servicegebyrer',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Kontantindtægt fra leveringsgebyrer',
    },
    gross_cash_income_other: {
      label: 'Kontantindtægt fra servicetillæg',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Kontantindtægt fra viderefakturerede leveringsgebyrer',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Kontantindtægt fra platformens behandlingsgebyrer',
    },
    net_cash_income: {
      label: 'Kontantindtægt (netto)',
    },
    net_cash_income_subscription: {
      label: 'Kontantindtægt fra abonnementer',
    },
    net_cash_income_service_fee: {
      label: 'Kontantindtægt fra servicegebyrer',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Kontantindtægt fra leveringsgebyrer',
    },
    net_cash_income_other: {
      label: 'Kontantindtægt fra servicetillæg',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Kontantindtægt fra viderefakturerede leveringsgebyrer',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Kontantindtægt fra platformens behandlingsgebyrer',
    },
    manual_connect_transfers: {
      label: 'Refunderet til restauranter',
    },
    processing_fees: {
      label: 'Behandlingsgebyrer',
    },
    processing_fees_stripe: {
      label: 'Behandlingsgebyrer (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Behandlingsgebyrer (PayPal)',
    },
    rejected_orders: {
      label: 'Afviste ordrer',
    },
    rejected_orders_amount: {
      label: 'Beløb for afviste ordrer',
    },
    rejected_orders_count: {
      label: 'Antal afviste ordrer',
    },
    rejected_orders_rate: {
      label: 'Andel afviste ordrer',
    },
    rejected_orders_rate_breakdown: {
      label: 'Fordeling af afviste ordrer',
    },
    orders: {
      label: 'Ordrer',
    },
    total_orders: {
      label: 'Ordrer i alt',
    },
    pickup_orders_rate: {
      label: 'Andel afhentningsordrer',
    },
    delivery_orders_rate: {
      label: 'Andel leveringsordrer',
    },
    other_orders_rate: {
      label: 'Andel øvrige ordrer',
    },
    customers: {
      label: 'Kunder i alt',
    },
    customers_auth_state: {
      label: 'Kundegodkendelsesstatus',
    },
    website_reservations: {
      label: 'Reservationer via websted',
    },
    google_reservations: {
      label: 'Reservationer via Google',
    },
    companies: {
      label: 'Virksomheder',
    },
    live_companies: {
      label: 'Aktive restauranter',
    },
    live_companies_percentage: {
      label: 'Andel aktive restauranter',
    },
    setup_packages_breakdown: {
      label: 'Opsætningspakker',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Opsætningspakker efter faktureringskilde',
    },
    crossed_sales_level_this_month: {
      label: 'Nået salgsniveau denne måned',
    },
    crossed_sales_level_total: {
      label: 'Nået salgsniveau i alt',
    },
    crossed_sales_level_percentage: {
      label: 'Andel der har nået salgsniveau',
    },
    has_delivery: {
      label: 'Egen levering',
    },
    has_only_pickup: {
      label: 'Kun afhentning',
    },
    has_storefront: {
      label: 'Har webshop',
    },
    has_storefront_percentage: {
      label: 'Andel med webshop',
    },
    use_external_delivery: {
      label: 'Ekstern levering',
    },
    crossed_sales: {
      label: 'Nået {{value}} i salg',
    },
    restaurant_partners: {
      label: 'Restaurantpartnere',
    },
    registered_restaurants: {
      label: 'Registrerede restauranter',
    },
    signed_restaurants: {
      label: 'Tilmeldte restauranter',
    },
    use_reservations: {
      label: 'Bruger reservationer',
    },
    number: {
      label: 'Antal',
    },
    restaurants_percentage: {
      label: 'Andel restauranter',
    },
    crossed_sales_level: {
      label: 'Nået salgsniveau',
    },
    order_method: {
      label: 'Bestillingsmetode',
    },
    own_delivery: {
      label: 'Egen levering',
    },
    only_pickup: {
      label: 'Kun afhentning',
    },
    storefront: {
      label: 'Webshop',
    },
    sales_tiers: {
      label: 'Salgsniveauer',
    },
    new_pricing_adoption_rate: {
      label: 'Andel med ny prismodel',
    },
    mobile_app_attach_rate: {
      label: 'Andel med mobilapp',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Valgte opsætningsgebyrer for mobilapp',
    },
    first_delivery: {
      label: 'Uber (første levering)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Antal leveringstilbud',
    },
    deliveries_count: {
      label: 'Antal leveringer',
    },
    delivery_conversion: {
      label: 'Leveringskonverteringsrate',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Leveringstilbud fordelt på udbyder',
    },
    deliveries_provider_breakdown: {
      label: 'Leveringer fordelt på udbyder',
    },
    delivery_distance_breakdown: {
      label: 'Leveringer fordelt på afstand',
    },
    total_delivered: {
      label: 'Leverede beskeder',
    },
    website_visitors_from_google_business_profile: {
      label: 'Webstedsklik fra Google Business',
    },
    google_business_impressions: {
      label: 'Visninger fra Google Business',
    },
    google_business_website_clicks: {
      label: 'Webstedsklik fra Google Business',
    },
    google_ads_impressions: {
      label: 'Visninger Google Ads',
    },
    google_ads_clicks: {
      label: 'Klik Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Opkald Google Ads',
    },
    google_ads_directions: {
      label: 'Rutevejledninger Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: 'Gennemsnitlig absolut topvisningsandel Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Gennemsnitlig pris pr. klik Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Gennemsnitlig konverteringsrate fra interaktioner Google Ads',
    },
    website_visits: {
      label: 'Webstedsbesøg',
    },
    website_visitors: {
      label: 'Webstedsbesøgende',
    },
    companies_with_activated_reservations: {
      label: 'Restauranter med aktiverede reservationer',
    },
    online_orders_count: {
      label: 'Onlineordrer',
    },
    cash_orders_count: {
      label: 'Onlineordrer',
    },
    cash_sales: {
      label: 'Kontantsalg',
    },
    online_sales: {
      label: 'Onlinesalg',
    },
    payouts: {
      label: 'Udbetalinger',
    },
    last_payout_amount: {
      label: 'Seneste udbetaling',
    },
    pending_payout_amount: {
      label: 'Undervejs',
    },
    future_payout_amount: {
      label: 'Tilgængelig til fremtidige udbetalinger',
    },
    mobile_app_average_order_value: {
      label: 'Gns. ordreværdi via app',
    },
    mobile_app_gmv: {
      label: 'Samlet salg via app',
    },
    mobile_app_gmv_percentage: {
      label: 'Omsætningsandel fra app',
    },
    mobile_app_downloads: {
      label: 'App-downloads i alt',
    },
    mobile_app_orders_count: {
      label: 'Ordrer i alt via app',
    },
    net_billed_revenue_gift_cards: {
      label: 'Faktureret omsætning fra gavekort',
    },
    gross_cash_income_gift_cards: {
      label: 'Kontantindtægt fra gavekort',
    },
    net_cash_income_gift_cards: {
      label: 'Kontantindtægt fra gavekort',
    },
    platform_processing_fees: {
      label: 'Platformens behandlingsgebyrer',
    },
  },
};
